<script setup>
import StatCardComponent from "@/Components/PayPeriod/StatCardComponent.vue";
import UserCardComponent from "@/Components/UserCard/UserCardComponent.vue";
import DisbursementsComponent from "@/Components/Disbursements/DisbursementsComponent.vue";
import PayPeriodPersonUnreleasedComponent from "@/Components/HoldBacks/PayPeriodPersonUnreleasedComponent.vue";
import PayPeriodPersonReleasedComponent from "@/Components/HoldBacks/PayPeriodPersonReleasedComponent.vue";
import PayPeriodPersonAllUnreleasedComponent from "@/Components/HoldBacks/PayPeriodPersonAllUnreleasedComponent.vue";
import PayPeriodPersonComponent from "@/Components/Adjustments/PayPeriodPersonComponent.vue";
import {useRoute} from "vue-router";
import {Permissions} from "@/Utils/Permissions";
import {onMounted, reactive} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
const route = useRoute()

const data = reactive({
  loading: true,
  exists: false
});

const checkExists = async () => {
  data.loading = true;
  data.exists = false;

  let payPeriodExists = false;
  let personExists = false;

  if(route.params.payperiodId === undefined || route.params.payperiodId.toLowerCase() === 'undefined' || route.params.payperiodId.toLowerCase() === 'pending') {
    payPeriodExists = true;
  }
  else {
    await ApiWrapper.post('pay-period', 'pay-period-exists', {
      payPeriodId: route.params.payperiodId
    })
        .then((response) => {
          payPeriodExists = true;
        })
        .catch((e) => {
          payPeriodExists = false;
        });
  }

  await ApiWrapper.post('person', 'person-exists', {
    personId: route.params.personId
  })
      .then((response) => {
        personExists = true;
      })
      .catch((e) => {
        personExists = false;
      });

  data.exists = personExists && payPeriodExists;
  data.loading = false;
}

onMounted(() => {
  checkExists();
});

</script>

<template>
  <template v-if="data.loading">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-skeleton-loader type="card"></v-skeleton-loader>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && !data.exists">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-alert title="Not Found" text="The specified pay period and/or user could not be found" type="error"></v-alert>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && data.exists">
    <v-row>
      <v-col cols="6" v-if="Permissions.checkPermissions(['pay-periods.list'])">
        <StatCardComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId" contextSchemaB="person" :contextIdB="route.params.personId"/>
      </v-col>
      <v-col cols="6" v-if="Permissions.checkPermissions(['pay-periods.list'])">
        <UserCardComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId" contextSchemaB="person" :contextIdB="route.params.personId"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['pay-periods.disbursements'])">
      <v-col cols="12">
        <DisbursementsComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId" contextSchemaB="person" :contextIdB="route.params.personId"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['pay-periods.holdbacks'])">
      <v-col cols="12">
        <PayPeriodPersonUnreleasedComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId" contextSchemaB="person" :contextIdB="route.params.personId"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['pay-periods.holdbacks'])">
      <v-col cols="12">
        <PayPeriodPersonReleasedComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId" contextSchemaB="person" :contextIdB="route.params.personId"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['holdbacks.unreleased-current-person'])">
      <v-col cols="12">
        <PayPeriodPersonAllUnreleasedComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId" contextSchemaB="person" :contextIdB="route.params.personId"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['pay-periods.adjustments'])">
      <v-col cols="12">
        <PayPeriodPersonComponent contextSchemaA="payperiods" :contextIdA="route.params.payperiodId" contextSchemaB="person" :contextIdB="route.params.personId"/>
      </v-col>
    </v-row>
  </template>
</template>

<style scoped>

</style>